export const OPEN_TEXT_MIN_LENGTH = 3;
export const CHAT_MESSAGE_BODY_MIN_LENGTH = 3;

export const OPEN_TEXT_INCOMPLETE_MESSAGE =
  "Please provide a more complete answer (at least 3 characters, including a letter or number).";

export const CHAT_MESSAGE_INCOMPLETE_MESSAGE =
  "Please type your question (at least 3 characters, including a letter or number).";

const hasLetterOrNumber = (text: string): boolean => /[\p{L}\p{N}]/u.test(text);

export const isMeaningfulUserText = (
  text: string,
  minLength: number,
): boolean => {
  const trimmed = text.trim();
  return trimmed.length >= minLength && hasLetterOrNumber(trimmed);
};

// Open-text answers need ≥3 chars and at least one letter or digit.
export const isCompleteOpenTextAnswer = (answer: string): boolean =>
  isMeaningfulUserText(answer, OPEN_TEXT_MIN_LENGTH);
